import { render, staticRenderFns } from "./AkvelonLogo.vue?vue&type=template&id=23e7970e&"
import script from "./AkvelonLogo.vue?vue&type=script&lang=js&"
export * from "./AkvelonLogo.vue?vue&type=script&lang=js&"
import style0 from "./AkvelonLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports